import { render, staticRenderFns } from "./modalFppkKanbanDetail.vue?vue&type=template&id=a3001cee&scoped=true"
import script from "./modalFppkKanbanDetail.vue?vue&type=script&lang=js"
export * from "./modalFppkKanbanDetail.vue?vue&type=script&lang=js"
import style0 from "./modalFppkKanbanDetail.vue?vue&type=style&index=0&id=a3001cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3001cee",
  null
  
)

export default component.exports